import { createFileRoute } from "@tanstack/react-router";
import type { InboxFilter } from "@/components/notifications/api";
import { Inbox } from "@/components/notifications/Inbox";

type InboxSearch = { filter?: Exclude<InboxFilter, "all">; peek?: string };

/** /inbox, `?filter=unread|archived` (default: everything not archived), `?peek=KEY` for the preview panel. */
export const Route = createFileRoute("/_app/inbox")({
  validateSearch: (s: Record<string, unknown>): InboxSearch => ({
    filter: s.filter === "unread" || s.filter === "archived" ? s.filter : undefined,
    peek: typeof s.peek === "string" && s.peek ? s.peek : undefined,
  }),
  component: InboxPage,
});

function InboxPage() {
  const { filter } = Route.useSearch();
  return <Inbox filter={filter ?? "all"} />;
}
